import { render, staticRenderFns } from "./rightsloglist.vue?vue&type=template&id=4a63730c"
import script from "./rightsloglist.vue?vue&type=script&lang=js"
export * from "./rightsloglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports